<template>
<!-- <v-parallax height="600" :src="parallaxImage" :lazy-src="parallaxImage">
  <template v-slot:placeholder>
    <v-layout fill-height align-center justify-center ma-0>
      <v-progress-circular indeterminate color="grey darken-5"></v-progress-circular>
    </v-layout>
  </template>
</v-parallax> -->
<v-img height="600" :src="parallaxImage" :lazy-src="parallaxImage" aspect-ratio="1" class="grey lighten-2">
  <template v-slot:placeholder>
    <v-layout fill-height align-center justify-center ma-0>
      <v-progress-circular indeterminate color="grey darken-5"></v-progress-circular>
    </v-layout>
  </template>
</v-img>
</template>

<script>
export default {
  data() {
    return {
      parallaxImage: 'https://firebasestorage.googleapis.com/v0/b/sarithasangeetham-123.appspot.com/o/WhatsApp%20Image%202019-03-09%20at%2019.29.03.jpeg?alt=media&token=ed157bde-4f73-4664-9d6c-4f0bd755442e'
    }
  }
}
</script>

<style>

</style>
